import { CampaignId } from 'mini-campaign-bootstrap/lib/schema/CampaignId';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { isFocusedOtherCampaignVisible } from 'mini-mail-campaign-view/lib/util/focusedOtherCampaignUtils';
import { isMiniHostAppCampaignEnabled } from 'mini-campaign-bootstrap/lib/utils/isMiniHostAppCampaignEnabled';
import { shouldShowFocusedOtherButton } from './shouldShowFocusedOtherButton';

/**
 * Utility to determine if the focused other campaign is to be shown or not
 */
export const canShowFocusedOtherCampaign = () =>
    isMiniHostAppCampaignEnabled(CampaignId.MiniMailFocusOthers) &&
    shouldShowFocusedOtherButton() &&
    getListViewStore().canAllotSpaceForFocusedOtherCampaign &&
    isFocusedOtherCampaignVisible() &&
    IS_FOCUSSED_OTHER_CAMPAIGN_ENABLED;

/**
 * Soft deleting Focussed/Other campaigns, hence setting the value to false.
 * This code will be completely deleted at a later point.
 */
const IS_FOCUSSED_OTHER_CAMPAIGN_ENABLED: boolean = false;
